var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":_vm.title}},[_c('chartjs-component-bar-chart',{attrs:{"height":270,"data":_vm.chart,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }